import { useState } from 'react'
import ReactGA from 'react-ga4'
import ReactPlayer from 'react-player'
import { StaffComment } from '../../components/StaffComment'
import { FullScreenModal } from '../../utility/FullScreenModal'
import { SystemSS } from '../../components/SystemSS'

export const CharDlc = () => {
    const [hover, setHover] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [isPlaying, setIsPlaying] = useState(null)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const [modalImage, setModalImage] = useState()
    const [imageIndex, setImageIndex] = useState(1)
    const [subNum, setSubNum] = useState(null)
    const handleOpenModal = (imageName, subNum, imageIndex) => {
        setModalImage(imageName)
        setSubNum(subNum)
        setImageIndex(imageIndex)
        setShowModal(true)
        // console.log(subNum, imageIndex, dlcCharVideo[subNum])
    }
    const handleCloseModal = () => {
        setShowModal(false)
        setTimeout(() => {
            setSubNum(null)
            setImageIndex(1)
        }, 300)
    }
    const handlePrev = () => {
        setImageIndex((prevState) => (prevState > 1 ? prevState - 1 : prevState))
    }

    const handleNext = () => {
        setImageIndex((prevState) => (prevState < 4 ? prevState + 1 : prevState))
    }
    const dlcchardata = [
        {
            name: 'Castile',
            game: 'Phantom Brave',
            gamelink: 'https://nisamerica.com/phantombrave-remastered/',
        },
        {
            name: 'Walnut',
            game: 'Phantom Brave',
            gamelink: 'https://nisamerica.com/phantombrave-remastered/',
        },
        {
            name: 'Scarlet',
            game: 'Phantom Brave',
            gamelink: 'https://nisamerica.com/phantombrave-remastered/',
        },
        {
            name: 'Sprout',
            game: 'Phantom Brave',
            gamelink: 'https://nisamerica.com/phantombrave-remastered/',
        },
        {
            name: 'Samayoi',
            game: 'BAR Stella Abyss',
            gamelink: 'https://nippon1.jp/consumer/barstellaabyss/',
        },
        {
            name: 'Liar Princess',
            game: 'The Liar Princess and the Blind Prince',
            gamelink: 'https://www.nisamerica.com/the-liar-princess/',
        },
        {
            name: 'Kotomo',
            game: 'Yomawari: Night Alone',
            gamelink: 'https://nisamerica.com/yomawari/',
        },
        {
            name: 'Mad Rat & Heart',
            game: 'MAD RAT DEAD',
            gamelink: 'https://www.nisamerica.com/mad-rat-dead/',
        },
    ]
    const dlcCharVideo = {
        1: {
            1: 'https://youtu.be/RNyZZZYiQbY', // Action 1
            2: 'https://youtu.be/nOpqz_VEceM', // Action 2
            3: 'https://youtu.be/E_K8Uk04U9k', // Confriend
            4: 'https://youtu.be/fhK8jazFpLw', // Skill
        },
        2: {
            1: 'https://youtu.be/qBVT3mP_UU4',
            2: 'https://youtu.be/9fokQ7edU1U',
            3: 'https://youtu.be/eXlhDrvxOEQ',
            4: 'https://youtu.be/Bv5sbWfIdQY',
        },
        3: {
            1: 'https://youtu.be/yS3uPKHGPKU',
            2: 'https://youtu.be/xgZapJUcgU0',
            3: 'https://youtu.be/lGykttqGOHw',
            4: 'https://youtu.be/EBz6m7C50gc',
        },
        4: {
            1: 'https://youtu.be/Z9T7AOth6so',
            2: 'https://youtu.be/SJFZFWtfatY',
            3: 'https://youtu.be/hwP-lOvN1tg',
            4: 'https://youtu.be/LVsZRG-U2xw',
        },
        5: {
            1: 'https://youtu.be/YE7HpUxFOzo',
            2: 'https://youtu.be/gojrO6Y3jxE',
            3: 'https://youtu.be/HJDiBD9kMYY',
            4: 'https://youtu.be/aagqQgnTfks',
        },
        6: {
            1: 'https://youtu.be/Ll7XoDnDGA4',
            2: 'https://youtu.be/-5wRkh01mJA',
            3: 'https://youtu.be/SJtHn3HGBi0',
            4: 'https://youtu.be/-wELAVNglYc',
        },
        7: {
            1: 'https://youtu.be/FzHU2cChV2s',
            2: 'https://youtu.be/ASxwffAtvqw',
            3: 'https://youtu.be/UPSXt5YU9Fc',
            4: 'https://youtu.be/wA94-y3I54k',
        },
        8: {
            1: 'https://youtu.be/I-LW76j_0MQ',
            2: 'https://youtu.be/8LbRyQEiNfY',
            3: 'https://youtu.be/tJ4f-Wpa3wk',
            4: 'https://youtu.be/J6718pZ23P8',
        },
    }

    return (
        <div className='w-full  mx-autr pt-12 md:pt-0'>
            <img
                className='mx-auto mt-12'
                src={`${process.env.PUBLIC_URL}/images/characters/dlc/header-dlc-characters-fr.webp`}
                alt='unique characters you encounter on your journey'
            />
            <div className='max-w-[calc(1361px*0.75)] mx-auto px-2'>
                <div className='relative mx-auto h-0 w-full pt-[71.4180749449%]'>
                    {[...Array(8)].map((_, index) => {
                        const num = index + 1
                        return (
                            <div key={num}>
                                <a
                                    onClick={() => {
                                        ReactGA.event({
                                            action: 'click',
                                            event: 'link',
                                            category: 'Character',
                                            label: `Character-${num}`,
                                        })
                                    }}
                                    href={`#dlc-char-${num}`}
                                >
                                    <img
                                        onMouseEnter={() => setHover(num)}
                                        onMouseLeave={() => setHover(false)}
                                        className={`dlc-char${num} hover:brightness-110 duration-300 cursor-pointer`}
                                        src={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_nav_visual_0${num}.png`}
                                        alt={`character-${num} kv`}
                                    />
                                </a>
                                {hover === num && (
                                    <img
                                        className={`hidden md:block dlc-charinfo-${num}`}
                                        src={`${process.env.PUBLIC_URL}/images/characters/dlc/dlc-char-name-${num}-fr.webp`}
                                        alt='comment bubble'
                                    />
                                )}
                                <img
                                    className={`block md:hidden dlc-charinfo-${num}`}
                                    src={`${process.env.PUBLIC_URL}/images/characters/dlc/dlc-char-name-${num}.webp`}
                                    alt='comment bubble'
                                />
                            </div>
                        )
                    })}
                </div>{' '}
            </div>{' '}
            <div className='mt-20'>
                {' '}
                <img
                    className='mx-auto my-12'
                    src={`${process.env.PUBLIC_URL}/images/characters/dlc/header-parallel-siblings-fr.webp`}
                    alt='unique characters you encounter on your journey'
                />
                <p className='w-full md:w-4/5 mx-auto px-4 text-shadow-white text-pbnavy font-kiwi font-bold text-sm md:text-base text-center md:text-left'>
                    Le destin réunit Walnut et Marona lors d'improbables retrouvailles qui la laissent muette de
                    stupeur. Pire encore : Castille, miraculeusement guérie, surgit en déclarant venir d'un monde
                    parallèle. Qu'est-il réellement arrivé à Castille et à ses amis dans l'autre monde ?
                </p>{' '}
                <div className='px-4'>
                    <img
                        onClick={() => handleOpenModal('event', subNum, 1)}
                        className='w-full max-w-[700px] ss-thumb mx-auto text-center my-8 '
                        src={`${process.env.PUBLIC_URL}/images/ss/ss-dlc-event-1-fr-s.webp`}
                        alt='game screenshot'
                    />{' '}
                </div>
                {dlcchardata.slice(0, 2).map((chardata, i) => (
                    <section id={`dlc-char-${i + 1}`} className='mt-12 bg-char overflow-hidden'>
                        <div className='lg:w-[80vw] flex flex-col align-middle md:flex-row md:items-center relative mx-auto'>
                            <div className='character-info w-full md:w-1/2 lg:w-[60%] mx-auto z-10'>
                                <div className='w-full mx-auto my-6 md:my-12'>
                                    <div className='text-center'>
                                        <img
                                            className='max-w-full mx-auto text-center'
                                            src={`${process.env.PUBLIC_URL}/images/characters/dlc/char-name-dlc-${
                                                i + 1
                                            }-fr.webp`}
                                            alt={chardata.name}
                                        />{' '}
                                    </div>
                                    <div
                                        className={`movie-wrapper-${
                                            i + 1
                                        } text-center md:text-left md:pt-12 flex flex-col md:flex-row justify-center px-4 md:px-0 relative w-full mx-auto}`}
                                    >
                                        <div
                                            className={`[&>div]:w-[48%] [&>div>img]:ss-thumb gap-2 lg:gap-4 flex flex-wrap justify-center`}
                                        >
                                            {[...Array(4)].map((img, j) => (
                                                <div className='movie-container'>
                                                    <img
                                                        onClick={() => {
                                                            handleOpenModal('char', i + 1, j + 1)
                                                        }}
                                                        className='w-full min-w-none'
                                                        src={`${process.env.PUBLIC_URL}/images/ss/ss-dlc-char-${
                                                            i + 1
                                                        }-${j + 1}-fr-s.webp`}
                                                        alt='game screenshot'
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>{' '}
                                </div>
                            </div>{' '}
                            <div
                                className={`dlc-character-visual dlc-char-mobile-${i + 1} md:self-end md:translate-y-0`}
                            >
                                <picture className={`dlc-character-bustup0${i + 1} bottom-0`}>
                                    <source
                                        srcSet={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${
                                            i + 1
                                        }_sp.png`}
                                        media='(max-width: 768px)'
                                    ></source>
                                    <img
                                        className=''
                                        src={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${i + 1}.png`}
                                        alt={chardata.name}
                                    />{' '}
                                </picture>
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    href={chardata.gamelink}
                                    className='text-right md:text-center absolute bottom-4 md:bottom-8 font-humming text-shadow-white text-base underline text-pborange right-4 md:left-1/2 md:-translate-x-1/2 w-full'
                                >
                                    {chardata.game}
                                </a>
                                {/* <div>
                                <div className='absolute top-0 -translate-y-[1/2] lg:-translate-y-full left-1/2 -translate-x-1/2 w-4/5 lg:w-full text-center mx-auto'>
                                    {chardata.caption}
                                </div>
                            </div> */}
                            </div>
                        </div>
                    </section>
                ))}
                <StaffComment>
                    <p className=''>
                        Comme l'histoire originale de Walnut a été développée dans un autre jeu, nous avons choisi de
                        présenter sa relation avec Castille sous un nouvel angle.
                    </p>
                    <p>
                        Nous espérons que vous serez sensibles aux facettes inédites de cette fratrie, jamais dévoilées
                        dans le premier opus.
                    </p>{' '}
                    <p className='text-right mt-2'>(Jôbana Kento, scénariste)</p>
                </StaffComment>{' '}
            </div>
            <div className='mt-20 md:mt-40'>
                <img
                    className='mx-auto my-12'
                    src={`${process.env.PUBLIC_URL}/images/characters/dlc/header-heroes-of-the-past-fr.webp`}
                    alt='unique characters you encounter on your journey'
                />
                <div className='w-full md:w-4/5 mx-auto px-4 text-shadow-white text-pbnavy font-kiwi font-bold text-sm md:text-base text-center md:text-left'>
                    {' '}
                    <p>
                        Germe, le héros qui a consacré sa vie à sa vengeance vis-à-vis de Sulphur, est apparu devant
                        Marona.
                    </p>{' '}
                    <p>
                        Scarlet, héroïne légendaire du passé nourrissant la même haine, fait aussi son retour. Les héros
                        d'autrefois, assoiffés de vengeance, se jettent dans une bataille hors du temps.
                    </p>
                </div>{' '}
                <div className='px-4'>
                    <img
                        onClick={() => handleOpenModal('event', subNum, 2)}
                        className='w-full max-w-[700px] ss-thumb mx-auto text-center my-8'
                        src={`${process.env.PUBLIC_URL}/images/ss/ss-dlc-event-2-fr-s.webp`}
                        alt='game screenshot'
                    />{' '}
                </div>
                {dlcchardata.slice(2, 4).map((chardata, i) => {
                    const currentIndex = i + 3
                    return (
                        <section key={i} id={`dlc-char-${currentIndex}`} className='mt-12 bg-char overflow-hidden'>
                            <div className='lg:w-[80vw] flex flex-col align-middle md:flex-row md:items-center relative mx-auto '>
                                <div className='character-info w-full md:w-1/2 lg:w-[60%] mx-auto z-10'>
                                    <div className='w-full mx-auto my-6 md:my-12'>
                                        <div className='text-center'>
                                            <img
                                                className='max-w-full mx-auto text-center'
                                                src={`${process.env.PUBLIC_URL}/images/characters/dlc/char-name-dlc-${currentIndex}-fr.webp`}
                                                alt={chardata.name}
                                            />{' '}
                                        </div>
                                        <div
                                            className={`movie-wrapper-${currentIndex} text-center md:text-left md:pt-12 flex flex-col md:flex-row justify-center px-4 md:px-0 relative w-full mx-auto}`}
                                        >
                                            <div
                                                className={`[&>div]:w-[48%] [&>div>img]:ss-thumb gap-2 lg:gap-4 flex flex-wrap justify-center`}
                                            >
                                                {[...Array(4)].map((img, j) => (
                                                    <div className='movie-container'>
                                                        <img
                                                            onClick={() => {
                                                                handleOpenModal('char', currentIndex, j + 1)
                                                            }}
                                                            className='w-full min-w-none'
                                                            src={`${
                                                                process.env.PUBLIC_URL
                                                            }/images/ss/ss-dlc-char-${currentIndex}-${j + 1}-fr-s.webp`}
                                                            alt='game screenshot'
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>{' '}
                                    </div>
                                </div>{' '}
                                <div
                                    className={`dlc-character-visual dlc-char-mobile-${currentIndex} md:self-end md:translate-y-0`}
                                >
                                    <picture className={`dlc-character-bustup0${currentIndex} bottom-0`}>
                                        <source
                                            srcSet={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${currentIndex}_sp.png`}
                                            media='(max-width: 768px)'
                                        ></source>
                                        <img
                                            className=''
                                            src={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${currentIndex}.png`}
                                            alt={chardata.name}
                                        />{' '}
                                    </picture>
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        href={chardata.gamelink}
                                        className='text-right md:text-center absolute bottom-4 md:bottom-8 font-humming text-shadow-white text-base underline text-pborange right-4 md:left-1/2 md:-translate-x-1/2 w-full'
                                    >
                                        {chardata.game}
                                    </a>
                                    {/* <div>
                                <div className='absolute top-0 -translate-y-[1/2] lg:-translate-y-full left-1/2 -translate-x-1/2 w-4/5 lg:w-full text-center mx-auto'>
                                    {chardata.caption}
                                </div>
                            </div> */}
                                </div>
                            </div>
                        </section>
                    )
                })}{' '}
                <StaffComment>
                    <p className=''>
                        Pendant la phase de conception, notre ancien président Seko nous a demandé d'accorder à Germe
                        une sorte de rédemption. Nous avons donc développé une histoire approfondissant les deux héros,
                        en veillant à préserver la cohérence du premier opus.
                    </p>
                    <p>Nous sommes convaincus que vous serez satisfaits du résultat.</p>{' '}
                    <p className='text-right mt-2'>(Jôbana Kento, scénariste)</p>
                </StaffComment>{' '}
            </div>{' '}
            <div className='mt-20 md:mt-40'>
                <img
                    className='mx-auto my-12'
                    src={`${process.env.PUBLIC_URL}/images/characters/dlc/header-wandering-pirate-fr.webp`}
                    alt='unique characters you encounter on your journey'
                />
                <div className='w-full md:w-4/5 mx-auto px-4 text-shadow-white text-pbnavy font-kiwi font-bold text-sm md:text-base text-center md:text-left'>
                    {' '}
                    <p>
                        L'histoire commence avec un pirate que même Marona a du mal à calmer, et Vagabond, individu
                        mystérieux qui adore festoyer.
                    </p>{' '}
                    <p>
                        Malgré le mutisme apparent de ce dernier, son étrange magnétisme et son audace insensée
                        mettront-ils Marona et son groupe à l'épreuve ?
                    </p>
                </div>{' '}
                <div className='px-4'>
                    <img
                        onClick={() => handleOpenModal('event', subNum, 3)}
                        className='w-full max-w-[700px] ss-thumb mx-auto text-center my-8'
                        src={`${process.env.PUBLIC_URL}/images/ss/ss-dlc-event-3-fr-s.webp`}
                        alt='game screenshot'
                    />{' '}
                </div>
                {dlcchardata.slice(4, 5).map((chardata, i) => {
                    const currentIndex = i + 5
                    return (
                        <section key={i} id={`dlc-char-${currentIndex}`} className='mt-12 bg-char overflow-hidden'>
                            <div className=' lg:w-[80vw] flex flex-col align-middle md:flex-row md:items-center relative mx-auto '>
                                <div className='w-full md:w-1/2 lg:w-[60%] mx-auto z-10'>
                                    <div className='w-full mx-auto my-6 md:my-12'>
                                        <div className='text-center'>
                                            <img
                                                className='max-w-full mx-auto text-center'
                                                src={`${process.env.PUBLIC_URL}/images/characters/dlc/char-name-dlc-${currentIndex}-fr.webp`}
                                                alt={chardata.name}
                                            />{' '}
                                        </div>
                                        <div
                                            className={`movie-wrapper-${currentIndex} text-center md:text-left md:pt-12 flex flex-col md:flex-row justify-center px-4 md:px-0 relative w-full mx-auto}`}
                                        >
                                            <div
                                                className={`[&>div]:w-[48%] [&>div>img]:ss-thumb gap-2 lg:gap-4 flex flex-wrap justify-center`}
                                            >
                                                {[...Array(4)].map((img, j) => (
                                                    <div className='movie-container'>
                                                        <img
                                                            onClick={() => {
                                                                handleOpenModal('char', currentIndex, j + 1)
                                                            }}
                                                            className='w-full min-w-none'
                                                            src={`${
                                                                process.env.PUBLIC_URL
                                                            }/images/ss/ss-dlc-char-${currentIndex}-${j + 1}-fr-s.webp`}
                                                            alt='game screenshot'
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>{' '}
                                    </div>
                                </div>{' '}
                                <div
                                    className={`character-visual char-translate-y-${currentIndex} md:self-end md:translate-y-0`}
                                >
                                    <picture className={`dlc-character-bustup0${currentIndex} bottom-0 `}>
                                        <source
                                            srcSet={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${currentIndex}_sp.png`}
                                            media='(max-width: 768px)'
                                        ></source>
                                        <img
                                            className=''
                                            src={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${currentIndex}.png`}
                                            alt={chardata.name}
                                        />{' '}
                                    </picture>
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        href={chardata.gamelink}
                                        className='text-right md:text-center absolute bottom-4 md:bottom-8 font-humming text-shadow-white text-base underline text-pborange right-4 md:left-1/2 md:-translate-x-1/2 w-full'
                                    >
                                        {chardata.game}
                                    </a>
                                </div>
                            </div>
                        </section>
                    )
                })}{' '}
                <StaffComment>
                    <p className=''>
                        Le scénario de BAR Stella Abyss ayant été confié à Jôbana, c'est en toute confiance que nous
                        l'avons désigné comme responsable de cette histoire.
                    </p>
                    <p>
                        Le résultat ? Un scénario aussi captivant qu'authentique pour Vagabond qui, nous l'espérons,
                        vous plaira.
                    </p>{' '}
                    <p className='text-right mt-2'>(BAR Stella Abyss : Yû Mizokami)</p>
                </StaffComment>{' '}
            </div>{' '}
            <div className='mt-20 md:mt-40'>
                <img
                    className='mx-auto my-12'
                    src={`${process.env.PUBLIC_URL}/images/characters/dlc/header-liar-lost-fr.webp`}
                    alt='unique characters you encounter on your journey'
                />
                <div className='w-full md:w-4/5 mx-auto px-4 text-shadow-white text-pbnavy font-kiwi font-bold text-sm md:text-base text-center md:text-left'>
                    {' '}
                    <p>Marona et Abricot rencontrent une jeune fille à la recherche d'un proche dans le désert.</p>{' '}
                    <p>
                        Cette dernière se présente comme la princesse d'un petit royaume. Abricot, fan inconditionnelle
                        de princesses, est sous le charme.
                    </p>{' '}
                    <p>Marona, quant à elle, est plus méfiante et pense que cette jeune fille n'a rien d'humain...</p>
                </div>{' '}
                <div className='px-4'>
                    <img
                        onClick={() => handleOpenModal('event', subNum, 4)}
                        className='w-full max-w-[700px] ss-thumb mx-auto text-center my-8'
                        src={`${process.env.PUBLIC_URL}/images/ss/ss-dlc-event-4-fr-s.webp`}
                        alt='game screenshot'
                    />{' '}
                </div>
                {dlcchardata.slice(5, 6).map((chardata, i) => {
                    const currentIndex = i + 6
                    return (
                        <section id={`dlc-char-${currentIndex}`} className='mt-12 bg-char overflow-hidden'>
                            <div className='lg:w-[80vw] flex flex-col align-middle md:flex-row md:items-center relative mx-auto '>
                                <div className='character-info w-full md:w-1/2 lg:w-[60%] mx-auto z-10'>
                                    <div className='w-full mx-auto my-6 md:my-12'>
                                        <div className='text-center'>
                                            <img
                                                className='max-w-full mx-auto text-center'
                                                src={`${process.env.PUBLIC_URL}/images/characters/dlc/char-name-dlc-${currentIndex}-fr.webp`}
                                                alt={chardata.name}
                                            />{' '}
                                        </div>
                                        <div
                                            className={`movie-wrapper-${currentIndex} text-center md:text-left md:pt-12 flex flex-col md:flex-row justify-center px-4 md:px-0 relative w-full mx-auto}`}
                                        >
                                            <div
                                                className={`[&>div]:w-[48%] [&>div>img]:ss-thumb gap-2 lg:gap-4 flex flex-wrap justify-center`}
                                            >
                                                {[...Array(4)].map((img, j) => (
                                                    <div className='movie-container'>
                                                        <img
                                                            onClick={() => {
                                                                handleOpenModal('char', currentIndex, j + 1)
                                                            }}
                                                            className='w-full min-w-none'
                                                            src={`${
                                                                process.env.PUBLIC_URL
                                                            }/images/ss/ss-dlc-char-${currentIndex}-${j + 1}-fr-s.webp`}
                                                            alt='game screenshot'
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>{' '}
                                    </div>
                                </div>{' '}
                                <div
                                    className={`dlc-character-visual dlc-char-mobile-${currentIndex} md:self-end md:translate-y-0`}
                                >
                                    <picture className={`dlc-character-bustup0${currentIndex} bottom-0`}>
                                        <source
                                            srcSet={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${currentIndex}_sp.png`}
                                            media='(max-width: 768px)'
                                        ></source>
                                        <img
                                            className=''
                                            src={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${currentIndex}.png`}
                                            alt={chardata.name}
                                        />{' '}
                                    </picture>
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        href={chardata.gamelink}
                                        className='text-right text-sub md:text-base md:text-center absolute bottom-4 md:bottom-8 font-humming text-shadow-white underline text-pborange right-4 md:left-1/2 md:-translate-x-1/2 w-3/5 lg:w=4/5'
                                    >
                                        {chardata.game}
                                    </a>
                                    {/* <div>
                                <div className='absolute top-0 -translate-y-[1/2] lg:-translate-y-full left-1/2 -translate-x-1/2 w-4/5 lg:w-full text-center mx-auto'>
                                    {chardata.caption}
                                </div>
                            </div> */}
                                </div>
                            </div>
                        </section>
                    )
                })}{' '}
                <StaffComment>
                    <p className=''>
                        Le style du design original rappelle des dessins faits à la main, ce qui a posé un défi de
                        modélisation 3D. Après maintes expérimentations, le rendu final est sublime.
                    </p>
                    <p>
                        Les séquences animées, comme la transformation en loup, regorgent du charme de The Liar Princess
                        ! Le scénario, quant à lui, captive par ses rebondissements !
                    </p>
                    <p className='text-right mt-2'>(The Liar Princess and the Blind Prince : Sayaka Oda)</p>
                </StaffComment>{' '}
            </div>{' '}
            <div className='mt-20 md:mt-40'>
                <img
                    className='mx-auto my-12'
                    src={`${process.env.PUBLIC_URL}/images/characters/dlc/header-girl-ghost-fr.webp`}
                    alt='unique characters you encounter on your journey'
                />
                <div className='w-full md:w-4/5 mx-auto px-4 text-shadow-white text-pbnavy font-kiwi font-bold text-sm md:text-base text-center md:text-left'>
                    {' '}
                    <p>Une fillette égarée débarque sur l'île du Squelette.</p>{' '}
                    <p>
                        Marona et Abricot lui proposent leur aide pour retrouver sa famille... mais l'enfant panique
                        lorsqu'elle découvre qu'Abricot est un fantôme.
                    </p>{' '}
                    <p>Réussiront-elles à l'apprivoiser malgré sa peur ?</p>
                </div>
                <div className='px-4'>
                    {' '}
                    <img
                        onClick={() => handleOpenModal('event', subNum, 5)}
                        className='w-full max-w-[700px] ss-thumb mx-auto text-center my-8'
                        src={`${process.env.PUBLIC_URL}/images/ss/ss-dlc-event-5-fr-s.webp`}
                        alt='game screenshot'
                    />{' '}
                </div>
                {dlcchardata.slice(6, 7).map((chardata, i) => {
                    const currentIndex = i + 7
                    return (
                        <section id={`dlc-char-${currentIndex}`} className='mt-12 bg-char overflow-hidden'>
                            <div className='lg:w-[80vw] flex flex-col align-middle md:flex-row md:items-center relative mx-auto '>
                                <div className='character-info w-full md:w-1/2 lg:w-[60%] mx-auto z-10'>
                                    <div className='w-full mx-auto my-6 md:my-12'>
                                        <div className='text-center'>
                                            <img
                                                className='max-w-full mx-auto text-center'
                                                src={`${process.env.PUBLIC_URL}/images/characters/dlc/char-name-dlc-${currentIndex}-fr.webp`}
                                                alt={chardata.name}
                                            />{' '}
                                        </div>
                                        <div
                                            className={`movie-wrapper-${currentIndex} text-center md:text-left md:pt-12 flex flex-col md:flex-row justify-center px-4 md:px-0 relative w-full mx-auto}`}
                                        >
                                            <div
                                                className={`[&>div]:w-[48%] [&>div>img]:ss-thumb gap-2 lg:gap-4 flex flex-wrap justify-center`}
                                            >
                                                {[...Array(4)].map((img, j) => (
                                                    <div className='movie-container'>
                                                        <img
                                                            onClick={() => {
                                                                handleOpenModal('char', currentIndex, j + 1)
                                                            }}
                                                            className='w-full min-w-none'
                                                            src={`${
                                                                process.env.PUBLIC_URL
                                                            }/images/ss/ss-dlc-char-${currentIndex}-${j + 1}-fr-s.webp`}
                                                            alt='game screenshot'
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>{' '}
                                    </div>
                                </div>{' '}
                                <div
                                    className={`dlc-character-visual dlc-char-mobile-${currentIndex} md:self-end md:translate-y-0`}
                                >
                                    <picture className={`dlc-character-bustup0${currentIndex} bottom-0`}>
                                        <source
                                            srcSet={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${currentIndex}_sp.png`}
                                            media='(max-width: 768px)'
                                        ></source>
                                        <img
                                            className=''
                                            src={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${currentIndex}.png`}
                                            alt={chardata.name}
                                        />{' '}
                                    </picture>
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        href={chardata.gamelink}
                                        className='text-right md:text-center absolute bottom-4 md:bottom-8 font-humming text-shadow-white text-base underline text-pborange right-4 md:left-1/2 md:-translate-x-1/2 w-full'
                                    >
                                        {chardata.game}
                                    </a>
                                    {/* <div>
                                <div className='absolute top-0 -translate-y-[1/2] lg:-translate-y-full left-1/2 -translate-x-1/2 w-4/5 lg:w-full text-center mx-auto'>
                                    {chardata.caption}
                                </div>
                            </div> */}
                                </div>
                            </div>
                        </section>
                    )
                })}{' '}
                <StaffComment>
                    <p className=''>
                        L'idée de combattre des fantômes sous un soleil tropical crée un contraste aussi absurde que
                        génial.
                    </p>
                    <p>Ça a un côté rassurant que des fantômes bienveillants existent.</p>{' '}
                    <p className='text-right mt-2'>(Yomawari : Yû Mizokami)</p>
                </StaffComment>{' '}
            </div>{' '}
            <div className='mt-20 md:mt-40'>
                <img
                    className='mx-auto my-12'
                    src={`${process.env.PUBLIC_URL}/images/characters/dlc/header-rat-demons-fr.webp`}
                    alt='unique characters you encounter on your journey'
                />
                <div className='w-full md:w-4/5 mx-auto px-4 text-shadow-white text-pbnavy font-kiwi font-bold text-sm md:text-base text-center md:text-left'>
                    {' '}
                    <p>Marona et ses amis rencontrent un rat étrange qui domine les démons.</p>{' '}
                    <p>
                        Surnommée le Rat fou, son apparence adorable séduit instantanément Abricot, qui tente de
                        l'apprivoiser... mais il riposte avec une férocité inattendue !
                    </p>{' '}
                    <p>Car le Rat fou n'est qu'un rat insensé, assoiffé de vengeance contre l'humanité !</p>
                </div>
                <div className='px-4'>
                    <img
                        onClick={() => handleOpenModal('event', subNum, 6)}
                        className='w-full max-w-[700px] ss-thumb mx-auto text-center my-8'
                        src={`${process.env.PUBLIC_URL}/images/ss/ss-dlc-event-6-fr-s.webp`}
                        alt='game screenshot'
                    />{' '}
                </div>
                {dlcchardata.slice(7, 8).map((chardata, i) => {
                    const currentIndex = i + 8
                    return (
                        <section id={`dlc-char-${currentIndex}`} className='mt-12 bg-char overflow-hidden'>
                            <div className='lg:w-[80vw] flex flex-col align-middle md:flex-row md:items-center relative mx-auto '>
                                <div className='character-info w-full md:w-1/2 lg:w-[60%] mx-auto z-10'>
                                    <div className='w-full mx-auto my-6 md:my-12'>
                                        <div className='text-center'>
                                            <img
                                                className='max-w-full mx-auto text-center'
                                                src={`${process.env.PUBLIC_URL}/images/characters/dlc/char-name-dlc-${currentIndex}-fr.webp`}
                                                alt={chardata.name}
                                            />{' '}
                                        </div>
                                        <div
                                            className={`movie-wrapper-${currentIndex} text-center md:text-left md:pt-12 flex flex-col md:flex-row justify-center px-4 md:px-0 relative w-full mx-auto}`}
                                        >
                                            <div
                                                className={`[&>div]:w-[48%] [&>div>img]:ss-thumb gap-2 lg:gap-4 flex flex-wrap justify-center`}
                                            >
                                                {[...Array(4)].map((img, j) => (
                                                    <div className='movie-container'>
                                                        <img
                                                            onClick={() => {
                                                                handleOpenModal('char', currentIndex, j + 1)
                                                            }}
                                                            className='w-full min-w-none'
                                                            src={`${
                                                                process.env.PUBLIC_URL
                                                            }/images/ss/ss-dlc-char-${currentIndex}-${j + 1}-fr-s.webp`}
                                                            alt='game screenshot'
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>{' '}
                                    </div>
                                </div>{' '}
                                <div
                                    className={`dlc-character-visual dlc-char-mobile-${currentIndex} md:self-end md:translate-y-0`}
                                >
                                    <picture className={`dlc-character-bustup0${currentIndex} bottom-0`}>
                                        <source
                                            srcSet={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${currentIndex}_sp.png`}
                                            media='(max-width: 768px)'
                                        ></source>
                                        <img
                                            className=''
                                            src={`${process.env.PUBLIC_URL}/images/characters/dlc/chr_visual_0${currentIndex}.png`}
                                            alt={chardata.name}
                                        />{' '}
                                    </picture>
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        href={chardata.gamelink}
                                        className='text-right md:text-center absolute bottom-4 md:bottom-8 font-humming text-shadow-white text-base underline text-pborange right-4 md:left-1/2 md:-translate-x-1/2 w-full'
                                    >
                                        {chardata.game}
                                    </a>
                                </div>
                            </div>
                        </section>
                    )
                })}{' '}
                <StaffComment>
                    <p className=''>
                        Je pensais la reproduction en 3D impossible... Pourtant, le modèle final n'a pas manqué de me
                        surprendre.
                    </p>
                    <p>Ma seule demande a été de le rendre aussi petit que possible.</p>{' '}
                    <p className='text-right mt-2'>(MAD RAT DEAD : Yû Mizokami)</p>
                </StaffComment>{' '}
            </div>{' '}
            {/* <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={4}
            /> */}
            <div
                onClick={handleCloseModal}
                className={`z-50 fixed top-0 left-0 w-full  h-full bg-black/80 ${showModal ? 'block' : 'hidden'}`}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    className='w-[90%] md:w-[80%]  max-w-[1920px] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 mx-auto z-30'
                >
                    <div className='relative'>
                        <button
                            onClick={handleCloseModal}
                            className='absolute top-0 right-0 -translate-y-full translate-x-1/4 md:-translate-y-full md:translate-x-full'
                        >
                            <img className='' src={`${process.env.PUBLIC_URL}/images/close.png`} alt={`close`} />{' '}
                        </button>
                        <div className=''>
                            {/* {modalImage === 'char' && (
                                    <>
                                        <div className='flex justify-center items-center md:relative'>
                                            <div className='hidden md:flex flex-col justify-center items-center'>
                                                <button onClick={handlePrev} disabled={imageIndex <= 1}>
                                                    <img
                                                        className={`w-full mx-2 min-w-[30px] max-w-[30px] ${
                                                            imageIndex <= 1 ? 'brightness-50' : ''
                                                        }`}
                                                        src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                                        alt='left'
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )}{' '} */}
                            {modalImage === 'char' ? (
                                <div onClick={(e) => e.stopPropagation()} className='h-full w-full'>
                                    <div className='player-wrapper' />
                                    {dlcCharVideo?.[subNum]?.[imageIndex] && (
                                        <ReactPlayer
                                            url={dlcCharVideo[subNum][imageIndex]}
                                            controls={true}
                                            onPlay={() => {
                                                setIsPlaying(1)
                                            }}
                                            width='100%'
                                            height='100%'
                                            playing={isPlaying === 1}
                                            config={{
                                                youtube: {
                                                    playerVars: { showinfo: 1 },
                                                },
                                            }}
                                            className='react-player bg-black'
                                        />
                                    )}
                                </div>
                            ) : (
                                <img
                                    className='white-drop-shadow max-w-[1920px] mx-auto w-full'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-dlc-${modalImage}${
                                        subNum ? `-${subNum}` : ''
                                    }-${imageIndex}-fr.webp`}
                                    alt={`screen shot of game system`}
                                />
                            )}
                            {/* {modalImage === 'char' && (
                                    <>
                                        <div className='flex justify-center items-center md:relative'>
                                            <div className='hidden md:flex flex-col justify-center items-center'>
                                                <button onClick={handleNext} disabled={imageIndex >= 4}>
                                                    <img
                                                        className={`w-full mx-2 min-w-[30px] max-w-[30px] ${
                                                            imageIndex >= 4 ? 'brightness-50' : ''
                                                        }`}
                                                        src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                                        alt='right'
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                        <div className='flex md:hidden justify-between w-full mt-4'>
                                            <button onClick={handlePrev} disabled={imageIndex <= 1}>
                                                <img
                                                    className={`w-full min-w-[30px] max-w-[30px] ${
                                                        imageIndex <= 1 ? 'brightness-50' : ''
                                                    }`}
                                                    src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                                    alt='left'
                                                />
                                            </button>
                                            <button onClick={handleNext} disabled={imageIndex >= 4}>
                                                <img
                                                    className={`w-full min-w-[30px] max-w-[30px] ${
                                                        imageIndex >= 4 ? 'brightness-50' : ''
                                                    }`}
                                                    src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                                    alt='right'
                                                />
                                            </button>
                                        </div>{' '}
                                    </>
                                )} */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
